export type Bonus = {
  number: string
  title: string
  body: string
  /** URL pública de la portada. Vacío = se muestra una portada diseñada de respaldo. */
  cover: string
  accent: string
}

/**
 * Los 5 bonus reales del pack (Bonus - DPS64.docx · Small Engine Diagnostic Pro).
 * Portadas pendientes: cuando estén los mockups, pegá la URL pública en `cover`.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Symptom-to-Card Finder',
    body: 'Look up the symptom and the machine on one grid and get the exact Bench Card numbers to run, in order. No scrolling through six volumes with greasy hands — plus an A–Z index of all 161 Bench Cards and 31 worksheets.',
    cover: '',
    accent: 'bg-ember',
  },
  {
    number: '02',
    title: '7-Day Shop Rollout Plan',
    body: 'A day-by-day plan to put the system to work in one week: what to print, where to post it, which worksheet to start with, your first carb with the Carb Decision Gate and your first pickup with the Pickup-Ready Workflow.',
    cover: '',
    accent: 'bg-patrol-mustard',
  },
  {
    number: '03',
    title: 'My Engine Spec Notebook',
    body: 'A fill-in spec book for the engine families you see most. Look up the official numbers once, write them down once, and have them on the bench every time after. 40 blank sheets plus a one-page guide to fill it in right.',
    cover: '',
    accent: 'bg-sky',
  },
  {
    number: '04',
    title: 'Customer Care Take-Home Sheets',
    body: '12 plain-English sheets you hand the customer at pickup — fuel care at home, end-of-season storage, pre-use checks, safe generator use — so the machine you just fixed doesn’t come back with the same problem. Space for your shop logo.',
    cover: '',
    accent: 'bg-signal',
  },
  {
    number: '05',
    title: 'Worldwide Shop Conversion & Terminology Cards',
    body: 'Quick cards for the numbers and words that change across the US, UK, Canada and Australia — lb-ft and N·m, US and imperial gallons, psi and bar, gas and petrol, string trimmer and line trimmer — so nothing gets lost between manual, parts catalog and customer.',
    cover: '',
    accent: 'bg-moss',
  },
]
